
import {UserPublicProfile,UserPrivateProfile, UserNotifications, UserSettings} from "../../common-datatypes"
import { getDoc } from "firebase/firestore";
import { Component ,Mixins} from "vue-property-decorator";
import Common from '@/mixins/common'
//import { NoticeProps } from "@/scripts/datatypes"
//import { ValidationObserver } from 'vee-validate'
//import { ValidationResult,ValidationFlags } from 'vee-validate/dist/types/types';
//import {toHiragana,toZenKana} from 'jaconv'

@Component({
  components: {
  }
})

export default class UserPreferences extends Mixins(Common) {
  isLoading = false
  userPublicProfile = {} as UserPublicProfile
  userPrivateProfile = {} as UserPrivateProfile
  userNotifications = {} as UserNotifications
  userSettings = {} as UserSettings

  get isStaff(){
    return this.$store.getters.isStaff as boolean
  }

  async mounted(){
    console.log('mounted')
  }

  get hasOtherSettings(){
    return this.userSettings.previewRequired && this.isStaff === false
  }

  get hasNotifications(){
    return Object.keys(this.userNotifications).length > 3 && (Object.values(this.userNotifications['messages']).includes(true) || Object.values(this.userNotifications['reminders']).includes(true) || Object.values(this.userNotifications['events']).includes(true))
  }

  async created() {
    console.trace('created')

    this.isLoading = true

    try{

    this.userPublicProfile = {
      ...this.$store.state.userPublicProfile,
      }

      this.userPrivateProfile = {
        ...this.$store.state.userPrivateProfile
      }

      const [userNotificationsDoc,userSettingsDoc] = await Promise.all([
        getDoc(this.$getUserNotificationsDocRef()),
        getDoc(this.$getUserSettingsDocRef())
      ])

      if(userNotificationsDoc.exists()){
        this.userNotifications = userNotificationsDoc.data() as UserNotifications
      }

      if(userSettingsDoc.exists()){
        this.userSettings = userSettingsDoc.data() as UserSettings
      }
    }catch(e){
      console.error(e)
    }finally{
      this.isLoading = false
    }
  }

  disableMethod(method: 'line' | 'sms' | 'email'){
    if(method === 'email'){
      return ! this.userPrivateProfile.email
    }

    if(method === 'sms'){
      return ! this.userPrivateProfile.phoneNumber
    }

    if(method === 'line'){
      return ! this.userPrivateProfile.lineUserId
    }
  }
}
